module.exports = __webpack_public_path__ + "img/phasesChantier.e1523f5f.png";